(function () {
  function initSpraypay(container) {
    var amountEl = container.querySelector('#pw-spraypay-amount');
    var trigger = container.querySelector('#pw-spraypay-trigger');
    var drawer = document.getElementById('pw-spraypay-drawer');

    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    if (trigger && drawer) {
      customElements.whenDefined('side-drawer').then(function () {
        trigger.addEventListener('click', function () {
          drawer.open(trigger);
        });
      });
    }

    if (!amountEl) return;

    var multiplier = parseFloat(container.dataset.multiplier) || 0.03321;
    var minCents = parseInt(container.dataset.minCents, 10) || 15000;

    function updateAmount(priceCents) {
      if (priceCents < minCents) {
        container.hidden = true;
        return;
      }
      container.hidden = false;
      var monthlyCents = Math.round(priceCents * multiplier);
      var euros = Math.floor(monthlyCents / 100);
      var cents = monthlyCents % 100;
      amountEl.textContent = '€' + euros + ',' + (cents < 10 ? '0' : '') + cents;
    }

    document.addEventListener('on:variant:change', function (evt) {
      var section = container.closest('[data-section-id]');
      if (!section) return;
      var eventSection = evt.detail && evt.detail.sectionId;
      if (eventSection && eventSection !== section.dataset.sectionId) return;
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      updateAmount(variant.price);
    });
  }

  function setup() {
    var containers = document.querySelectorAll('#pw-spraypay-bar[data-multiplier]');
    containers.forEach(function (container) {
      initSpraypay(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
